<template>
  <div class="container-fluid border-end">
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="transferringAgency" class="form-label"
          >Transferring Agency</label
        >
        <input
          type="text"
          class="form-control"
          id="transferringAgency"
          v-model="transferringAgency"
        />
      </div>
      <div class="mb-3">
        <label for="transferStartDate" class="form-label"
          >Transfer Date Range - Start</label
        >
        <input
          type="date"
          class="form-control"
          id="startDate"
          v-model="transferStartDate"
        />
      </div>
      <div class="mb-3">
        <label for="transferEndDate" class="form-label"
          >Transfer Date Range - End</label
        >
        <input
          type="date"
          class="form-control"
          id="transferEndDate"
          v-model="transferEndDate"
        />
      </div>
      <div class="mb-3">
        <label for="ingestionStartDate" class="form-label"
          >Ingestion Date Range - Start</label
        >
        <input
          type="date"
          class="form-control"
          id="ingestionStartDate"
          v-model="ingestionStartDate"
        />
      </div>
      <div class="mb-3">
        <label for="ingestionEndDate" class="form-label"
          >Ingestion Date Range - End</label
        >
        <input
          type="date"
          class="form-control"
          id="ingestionEndDate"
          v-model="ingestionEndDate"
        />
      </div>
      <div class="mb-3">
        <label for="securityGrading" class="form-label">Security Grading</label>
        <select
          id="securityGrading"
          class="form-select"
          v-model="securityGrading"
        >
          <option selected value=""></option>
          <option value="[`Official (Open)`]">Official (Open)</option>
          <option value="[`Official (Closed)`]">Official (Closed)</option>
          <option value="[`Restricted`]">Restricted</option>
          <option value="[`Confidential (Cloud-eligible)`]">
            Confidential (Cloud-eligible)
          </option>
          <option value="[`Confidential`]">Confidential</option>
          <option value="[`Secret`]">Secret</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="sensitivityClassification" class="form-label"
          >Sensitivity Classification</label
        >
        <select
          id="sensitivityClassification"
          class="form-select"
          v-model="sensitivityClassification"
        >
          <option selected value=""></option>
          <option value="[`Non-Sensitive`]">Non-Sensitive</option>
          <option value="[`Sensitive Normal`]">Sensitive Normal</option>
          <option value="[`Sensitive High`]">Sensitive High</option>
        </select>
      </div>
      <!-- <div class="mb-3">
        <label for="fileFormat" class="form-label">File Format</label>
        <select id="fileFormat" class="form-select" v-model="fileFormat">
          <option selected>Select...</option>
          <option>File Format 1</option>
          <option>File Format 2</option>
          <option>File Format 3</option>
        </select>
      </div> -->
      <!-- <fieldset class="mb-3">
        <legend class="col-form-label pt-0">File Format Category List</legend>
        <div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="category"
              id="blacklist"
              v-model="blacklist"
            />
            <label class="form-check-label" for="blacklist">Blacklist</label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="category"
              id="greylistHigh"
              v-model="greylistHigh"
            />
            <label class="form-check-label" for="greylistHigh"
              >Greylist - High Risk</label
            >
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="category"
              id="greylistModerate"
              v-model="greylistModerate"
            />
            <label class="form-check-label" for="greylistModerate"
              >Greylist - Moderate Risk</label
            >
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="category"
              id="whitelist"
              v-model="whitelist"
            />
            <label class="form-check-label" for="whitelist">Whitelist</label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="category"
              id="unlisted"
              v-model="unlisted"
            />
            <label class="form-check-label" for="unlisted">Converted</label>
          </div>
        </div>
      </fieldset> -->
      <fieldset class="mb-3">
        <legend class="col-form-label pt-0">Representation</legend>
        <div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              name="representation"
              id="master"
              v-model="master"
            />
            <label class="form-check-label" for="master">Master</label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              name="representation"
              id="access"
              v-model="access"
            />
            <label class="form-check-label" for="access">Access</label>
          </div>
          <!-- <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="representation"
              id="native"
              v-model="native"
            />
            <label class="form-check-label" for="native">Native</label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="representation"
              id="converted"
              v-model="converted"
            />
            <label class="form-check-label" for="converted">Converted</label>
          </div> -->
        </div>
      </fieldset>
      <div class="d-block">
        <button
          class="btn btn-clear btn-outline-secondary"
          type="button"
          @click="clear"
        >
          Clear All
        </button>
        <button
          class="btn btn-search btn-primary"
          type="button"
          @click="submitForm"
        >
          Search
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import moment from "moment";
import { ref } from "vue";
import { useAuditStore } from "@/stores/audit";

const emit = defineEmits(["listen-search"]);
const audit = useAuditStore();

const transferringAgency = ref("");
const transferStartDate = ref(null);
const transferEndDate = ref(null);
const ingestionStartDate = ref(null);
const ingestionEndDate = ref(null);
const securityGrading = ref("");
const sensitivityClassification = ref("");
const fileFormat = ref("");
const blacklist = ref(null);
const greylistHigh = ref(null);
const greylistModerate = ref(null);
const whitelist = ref(null);
const unlisted = ref(null);
const master = ref(true);
const access = ref(true);
const native = ref(null);
const converted = ref(null);
const representation = ref("");

const convertedTransferDate = ref("");
const convertedIngestionDate = ref("");
const dayRange = 86399;

const clear = () => {
  transferringAgency.value = "";
  transferStartDate.value = null;
  transferEndDate.value = null;
  ingestionStartDate.value = null;
  ingestionEndDate.value = null;
  securityGrading.value = "";
  sensitivityClassification.value = "";
  convertedTransferDate.value = "";
  convertedIngestionDate.value = "";
  fileFormat.value = "";
  blacklist.value = null;
  greylistHigh.value = null;
  greylistModerate.value = null;
  whitelist.value = null;
  unlisted.value = null;
  master.value = true;
  access.value = true;
  native.value = null;
  converted.value = null;
  representation.value = "";
  let searchField = {
    transfer_batch: transferringAgency.value,
    transfer_date: convertedTransferDate.value,
    security_grading: securityGrading.value,
    sensitivity_classification: sensitivityClassification.value,
    date_of_ingestion: convertedIngestionDate.value,
  };
  emit("listen-search", searchField);
};

const submitForm = () => {
  audit.auditLog("Search");
  if (transferStartDate.value && transferEndDate.value) {
    convertedTransferDate.value = `[${moment(
      transferStartDate.value
    ).unix()}..${moment(transferEndDate.value).unix() + dayRange}]`;
  } else if (transferStartDate.value) {
    convertedTransferDate.value = `[${moment(
      transferStartDate.value
    ).unix()}..${moment(transferStartDate.value).unix() + dayRange}]`;
  } else if (transferEndDate.value) {
    convertedTransferDate.value = `[${moment(transferEndDate.value).unix()}..${
      moment(transferEndDate.value).unix() + dayRange
    }]`;
  }

  if (ingestionStartDate.value && ingestionEndDate.value) {
    convertedIngestionDate.value = `[${moment(
      ingestionStartDate.value
    ).unix()}..${moment(ingestionEndDate.value).unix() + dayRange}]`;
  } else if (ingestionStartDate.value) {
    convertedIngestionDate.value = `[${moment(
      ingestionStartDate.value
    ).unix()}..${moment(ingestionStartDate.value).unix() + dayRange}]`;
  } else if (ingestionEndDate.value) {
    convertedIngestionDate.value = `[${moment(
      ingestionEndDate.value
    ).unix()}..${moment(ingestionEndDate.value).unix() + dayRange}]`;
  }

  if ((!master.value && !access.value) || (master.value && access.value))
    representation.value = "";
  else if (master.value && !access.value) representation.value = "Preservation";
  else if (!master.value && access.value) representation.value = "Access";

  let searchField = {
    transfer_batch: transferringAgency.value,
    transfer_date: convertedTransferDate.value,
    security_grading: securityGrading.value,
    sensitivity_classification: sensitivityClassification.value,
    date_of_ingestion: convertedIngestionDate.value,
    representation: representation.value,
  };
  emit("listen-search", searchField);
};
</script>

<style scoped>
.container-fluid {
  position: fixed;
  padding-top: 20px;
  width: 24%;
  height: 100%;
  overflow: auto;
}
.btn-clear {
  margin-top: 1rem;
  margin-right: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
.btn-search {
  margin-top: 1rem;
  margin-left: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
</style>
